import Service from "../../Services";

const VenueHire = {
  namespaced: true,
  state: {
    form: {
      id: "",
      branch_id: "",
      name_th: "",
      name_en: "",
      description_en: "",
      description_th: "",
      slug_url: "",
      manual_url: "",
      contract_email: "",
      contract_info: "",
      is_publish: true,
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        branch_id: "",
        name_th: "",
        name_en: "",
        description_en: "",
        description_th: "",
        slug_url: "",
        manual_url: "",
        contract_email: "",
        contract_info: "",
        is_publish: true,
      };
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getVenueHire({ commit }, page) {
      return Service.VenueHireAPI.getVenueHire(page);
    },
    // eslint-disable-next-line no-unused-vars
    showVenueHire({ commit }, id) {
      return Service.VenueHireAPI.showVenueHire(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveVenueHire({ commit }, { id, data }) {
      if (id) {
        return Service.VenueHireAPI.updateVenueHire(id, data);
      } else {
        return Service.VenueHireAPI.createVenueHire(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteVenueHire({ commit }, id) {
      return Service.VenueHireAPI.deleteVenueHire(id);
    },
    // eslint-disable-next-line no-unused-vars
    getAllVenueHire({ commit }) {
      return Service.VenueHireAPI.getVenueHireAll();
    },
    setFormVenueHire({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
  }
};
export default VenueHire;
